module.exports = __webpack_public_path__ + "static/media/24.04d106ec.png";